import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
	name: 'moment'
})
export class MomentPipe implements PipeTransform {

	/**
	 * Transforme une date en string formatée
	 *
	 * @param dateInput - La date à formater (string)
	 * @param format - Le format de sortie (ex: 'DD-MM-YY HH:mm')
	 * @param timezone - Fuseau horaire optionnel :
	 *                   - undefined (défaut) : conversion automatique si la date est au format UTC
	 *                     (suffixe 'Z' ou offset +HH:mm), sinon traitement naïf (comportement historique)
	 *                   - 'paris' ou 'Europe/Paris' : force l'interprétation en UTC et convertit vers Paris
	 *
	 * Exemples :
	 *   {{'2026-08-26T15:30:00Z' | moment: 'HH:mm'}}           // Auto-détecté UTC → converti en heure de Paris
	 *   {{'2026-08-26 15:30:00' | moment: 'HH:mm'}}            // Naïf, pas de conversion
	 *   {{date | moment: 'DD-MM-YY HH:mm': 'paris'}}           // Force la conversion UTC → Paris
	 */
	transform(dateInput: string, format: string, timezone?: string) {
		if (!dateInput) {
			return '';
		}

		let date: moment.Moment;

		// Si conversion vers Paris demandée, interpréter comme UTC et convertir
		if (timezone === 'paris' || timezone === 'Europe/Paris') {
			date = moment.utc(dateInput);

			if (!date.isValid()) {
				date = moment.utc(dateInput, 'YYYY-MM-DD HH:mm:ss');
			}

			if (!date.isValid()) {
				console.error('Invalid date:', dateInput);
				return 'Invalid date';
			}

			// Convertir en heure de Paris (gestion auto été/hiver)
			date = date.tz('Europe/Paris');
		} else {
			// Comportement par défaut : détecter automatiquement les dates UTC (suffixe Z ou offset +HH:mm)
			// et les convertir vers l'heure de Paris. Les dates naïves (sans indication de fuseau)
			// restent traitées comme avant (pas de conversion), pour ne pas casser les autres usages.
			const isUtcFormatted = typeof dateInput === 'string' && /Z$|[+-]\d{2}:?\d{2}$/.test(dateInput);

			if (isUtcFormatted) {
				date = moment.utc(dateInput).tz('Europe/Paris');
			} else {
				date = moment(dateInput, 'YYYY-MM-DD HH:mm:ss');
			}

			if (!date.isValid()) {
				console.error('Invalid date:', dateInput);
				return 'Invalid date';
			}
		}

		return date.format(format);
	}
	
}
